/* eslint-disable max-lines-per-function */
import React, {JSX, useEffect, useState } from 'react';
import Styles from './AccessoryCard.module.scss';
// import FalconButton from '@/components/shared/FalconButton/falconButton';
import { MultiItemAccessoriesSchema } from '../MultiItemAccessories/MultiItemAccessoriesSchema';
import DeviceCarouselComponent from '../DeviceCarouselComponent';
import Row from '../../ResponsiveRow/row';
// import GenericImage from '../../GenericImage/GenericImage';
import { getCompressedImage } from '../../../utils/utils';
import { getCookie } from 'cookies-next';
import FalconButtonV2 from '../../FalconButtonV2/FalconButtonV2';
import { countZero, replacePlaceholder } from '../../../utils/utils';
import AccessoryModal from './AccessoryModal';
import RichText from '../../richtext';
import { viewport } from '../../../utils/utils';
import { ACCORDIONCLICK, ADD_TO_CART, CLOSE, CLOSEPOPUP, CONTINUE, CTABUTTONCLICK, FORM, GAEVENT, INFO, KEEPPREVIOUS, LINK, OPEN, OPENPOPUP, POPUP, REMOVEFROMCART, REPLACE, REPLACESELECTION, TABCLICK } from '../../../Analytics/AnalyticsConstants';
import { trackViewItem } from '../../../utils/AnalyticsUtils';
import { MONTHLY, ONETIME, CONTRACT, MOBILERATEPLAN, TV, INTERNETFLOW, ACCESSORY, WATCHES, TABLETS, HARDWARE, ADD, REMOVE, FLEX_UPGRADE } from '../../../utils/constants';
import { useMultiAccessoryContext } from '../multiItemAccessoryStore/useMultiAccessoryContext';
import { useMultiAccessoryActions } from '../multiItemAccessoryStore/useMultiAccessoryActions';
import { buildSingleItemCartPayload, useMultiAccessoryUpdateCartActions } from '../multiItemAccessoryStore/useMultiAccessoryUpdateCartActions';
import { AssetPathPropConfig } from '../../../services';
import { trackNewDatalayerEvent } from '../../../utils/AnalyticsUtils';

type AccessoryCardProps = {
  content: MultiItemAccessoriesSchema;
  tabIndex: number;
  checkingviewPort: any;
  isSubscriptionFlow: boolean;
  setAccessoriesSelected?: (accessories: any[]) => void;
};

// eslint-disable-next-line max-lines-per-function
const AccessoryCard = ({
  content,
  tabIndex,
  isSubscriptionFlow,
  setAccessoriesSelected
}: AccessoryCardProps): JSX.Element => {
  const cartId = getCookie('one-commerce-cartId');
  const [show, setShow] = useState(false);
  const viewPort = viewport();
  const [showCartLimitError, setShowCartLimitError] = useState(false);
  const [pendingItem, setPendingItem] = useState<any>(null);
  const [pendingItemIndex, setPendingItemIndex] = useState<number>(0);
  const { store, dispatch } = useMultiAccessoryContext();
  const actions = useMultiAccessoryActions(dispatch);
  const cartActions = useMultiAccessoryUpdateCartActions();
  const { updateAccessoryCartFailure } = store; // for MultiAccessoryUpdateCart state
  //for multiAccessory recommendation api state
  const { multiItemAccessoriessList, deviceSessionValues, selectedPaymentType, recommendedAccessories, cartData, loading, showMiniCart } = store;
  //check for WIN/rateplan flow
 const ratePlanFlow = [MOBILERATEPLAN ]?.includes?.(recommendedAccessories?.[store?.selectedTab]?.hardware?.[0]?.recommendationProcessingType) ? true : (deviceSessionValues?.hardwareVariant ? false : true);
  const accessoriesLimit: any = {
    [ACCESSORY]: isSubscriptionFlow
      ? (ratePlanFlow ? +content?.ratePlanAccessoriesLimit : +content?.winAccessoriesLimit)
      : +content?.accessoriesLimit,
    WATCHES: 1,
    TABLETS: 1,
  };
  const setShowMiniCart = (value: boolean) => {
    trackNewDatalayerEvent(GAEVENT, ACCORDIONCLICK, {
      component: FORM,
      click_text: value ? OPEN : CLOSE
    });
    actions.setShowMiniCart(value);
  }

  const limitWarningText = JSON.parse(
    replacePlaceholder(JSON.stringify(content?.cartLimitWarningText), [
      accessoriesLimit?.[store.selectedTab].toString()
    ])
  );
  const basicConfigUrl = AssetPathPropConfig?.getInstance()?.getAssetPath();

  // Helper function to get selection popup content based on tab type
  const getSelectionPopupContent = () => {
    return store?.selectedTab === WATCHES 
      ? content?.watchesSelectionPopup?.[0] 
      : content?.tabletsSelectionPopup?.[0];
  };

  // Helper to fire immediate per-item cart API call
  const fireImmediateCartUpdate = (item: any, action: string) => {
    const cartItems = buildSingleItemCartPayload(item, action, store?.selectedTab, store);
    if (cartItems.length > 0) {
      cartActions.multiItemAccessorycreateCartRequest({
        id: cartId,
        redirectUrl: '',
        skipRedirect: true,
        previousTab: store?.selectedTab,
        cartItems,
      });
    }
  };

  // for handling add and remove accessories from cart
  const handleClickAddRemoveCartBtn = (e: any, item: any, index: number) => {
    e.preventDefault();
    if (cartData?.[store?.selectedTab]?.[item?.recomApiResponse?.id]) {
      // Item is in cart — remove it
      trackCTAButton(GAEVENT, REMOVEFROMCART, item, index);
      fireImmediateCartUpdate(item, REMOVE);
    } else {
      // Item not in cart — add it
      if (checkCartLimit(item, index)) {
        return;
      }
      trackCTAButton(ADD_TO_CART, ADD_TO_CART, item, index);
      fireImmediateCartUpdate(item, ADD);
    }
  };

  // Track analytics for CTA buttons
  const trackCTAButton = (event: string, eventName: string, item: any, index: number): void => {
    trackViewItem(event, eventName, {
      displayName: item?.recomApiResponse?.name,
      productId: item?.recomApiResponse?.id,
      priceValue: item?.recomApiResponse?.oneTimePrice?.base,
      index: index,
      variant: item?.recomApiResponse?.variantCategory?.color,
      storage: item?.recomApiResponse?.variantCategory?.storage,
      hardwareCategory: store?.selectedTab,
    });
  }
  // create cart function call — with real-time updates, just redirect
  const multiItemAccesoryCreatecart = (e: any) => {
    e.preventDefault();
    const isRetry = Object.keys(updateAccessoryCartFailure)?.length > 0;
    if (isRetry) {
      setShow(false);
      cartActions.setupdateAccessoryCartFailure({});
      return;
    }

    const redirectUrl = isSubscriptionFlow ? content?.winCheckoutUrl?.cached_url : content?.multiItemCheckoutUrl?.url;
    trackNewDatalayerEvent(GAEVENT, TABCLICK, {
      component: LINK,
      click_text: CONTINUE
    });
    window.location.href = redirectUrl;
  }

  // close the error popup when close/cancel button is clicked
  const onCloseClick = () => {
    setShow((prevState) => !prevState);
    if (Object.keys(updateAccessoryCartFailure)?.length > 0) {
      cartActions.setupdateAccessoryCartFailure({});
    }
  };
  // open the error popup when updated cart fails
  useEffect(() => {
    if (Object.keys(updateAccessoryCartFailure)?.length > 0) {
      setShow((prevState) => !prevState);
    }
  }, [updateAccessoryCartFailure]);

  // close the cartLimit popup when close/cancel button is clicked
  const onCloseClickCartLimitPopup = () => {
    setShowCartLimitError(false);
    setPendingItem(null);
    setPendingItemIndex(0);
  };

  // Handle "ClosePopup" - just close the modal without any changes
  const handleClosePopup = (modalContent?: any) => {
      // Track close popup event
    modalContent?.description && trackNewDatalayerEvent(GAEVENT, CLOSEPOPUP, {
      component: POPUP,
      message_title: REPLACESELECTION,
      message_description: modalContent?.description?.content?.[0]?.content?.[0]?.text?.slice(0, 100),
      message_type: INFO,
    });
    onCloseClickCartLimitPopup();
  };
  // Handle "Keep previous" - just close the modal without any changes
  const handleKeepPrevious = () => {
    trackNewDatalayerEvent(GAEVENT, CTABUTTONCLICK, {
      component: LINK,
      click_text: KEEPPREVIOUS
    });
    onCloseClickCartLimitPopup();
  };

  // Handle "Replace" - replace existing selection with new item via API
  const handleReplaceSelection = () => {
    trackNewDatalayerEvent(GAEVENT, CTABUTTONCLICK, {
      component: LINK,
      click_text: REPLACE
    });
    if (!pendingItem) {
      onCloseClickCartLimitPopup();
      return;
    }

    // Find the first item currently in cart for this tab and remove it, then add the new one
    const cartItems = multiItemAccessoriessList?.[store?.selectedTab] || [];
    const existingCartItem = cartItems.find((item: any) => 
      cartData?.[store?.selectedTab]?.[item?.recomApiResponse?.id]
    );
    
    if (existingCartItem) {
      trackCTAButton(GAEVENT, REMOVEFROMCART, existingCartItem, 0);
      fireImmediateCartUpdate(existingCartItem, REMOVE);
    }

    // Add the new pending item
    trackCTAButton(ADD_TO_CART, ADD_TO_CART, pendingItem, pendingItemIndex);
    fireImmediateCartUpdate(pendingItem, ADD);

    // Close the modal and clear pending item
    onCloseClickCartLimitPopup();
  };

  //show popup if cart limit reached
  const checkCartLimit = (item?: any, index?: number) => {
    const selectedAccCount = Object.keys(cartData?.[store?.selectedTab] || {}).length;
    if (selectedAccCount >= accessoriesLimit?.[store.selectedTab]) {
      setShowCartLimitError(true);
      setPendingItem(item || null);
      setPendingItemIndex(index || 0);
      return true;
    }
    return false;
  }
  //TODO: Remove checkingviewPort passing from multi-item

  // Handle delete from mini cart summary
  const handleDeleteFromMiniCart = async (item: any) => {
    const tabKey = item?.tabKey;
console.log('first', cartData?.[tabKey]?.[item?.recomApiResponse?.id])
    // Call API directly to remove it from cart
    if (cartData?.[tabKey]?.[item?.recomApiResponse?.id]) {
      await cartActions.removeItemFromCart(cartId, item);
    }

    trackCTAButton(GAEVENT, REMOVEFROMCART, item, 0);
  };

  // Helper function to calculate selected count for a tab
  const getTabSelectedCount = (tabKey: string) => {
    return Object.keys(cartData?.[tabKey] || {}).length;
  };
  const inTabSelected: Record<string, number> = {};
  const summaryIcons: Record<string, string> = {};
  const summaryLabels: Record<string, string> = {};

  (content?.recommendationType || []).map((tabKey: string) => {
    inTabSelected[tabKey] = getTabSelectedCount(tabKey);
    summaryIcons[`${tabKey}_icon`] = (content as any)?.[`${tabKey.toLowerCase()}Icon`]?.filename;
    summaryLabels[`${tabKey}_title`] = (content as any)?.[`selectionSummary${tabKey[0]}${tabKey.slice(1).toLowerCase()}Title`];
  });

  /**
   * Extract name and prices from from cartData.
   * Used as fallback when the item is not present in multiItemAccessoriessList.
   */
  const getCartItemDisplayInfo = (cartItems: any[]) => {
    if (!cartItems?.length) return null;

    const toNumberOrZero = (value: any) => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : 0;
    };

    const getCycleMonths = (cycle: any) => {
      const start = Number(cycle?.cycleStart);
      const end = Number(cycle?.cycleEnd);
      if (Number.isFinite(start) && Number.isFinite(end) && end >= start) {
        return (end - start) + 1;
      }
      return 1;
    };

    let name = '';
    let monthlyInstallment = 0;
    let oneTimePrice = 0;

    for (const item of cartItems) {
      if (!name) {
        name = item?.name || item?.productOffering?.name || item?.productOffering?.id || item?.id || '';
      }

      const prices = item?.itemPrice?.[0]?.cartPrice || [];
      const monthlyPrices = prices.filter((p: any) => p?.recurringChargePeriod === 'monthly');
      const originalInstallment = monthlyPrices
        .flatMap((p: any) => p?.additionalDetails || [])
        .find((d: any) => d?.id === 'originalInstallment')?.value;
      const paynowPrice = prices.find((p: any) => p?.recurringChargePeriod === 'paynow');
      const streetPrice = paynowPrice?.additionalDetails?.find((d: any) => d?.id === 'streetPrice')?.value;

      // Flat update-cart payloads expose prices under `item.prices`.
      const flatPrices = item?.prices || [];

      // Prefer cycleStart:1 recurring (monthly installment) over last-cycle recurring.
      const flatRecurringPrices = flatPrices.filter((p: any) => p?.priceType === 'RECURRING');
      const flatMonthly = (flatRecurringPrices.find((p: any) => p?.cycle?.cycleStart === 1) || flatRecurringPrices[0])?.value;
      const flatStreet = flatPrices.find((p: any) => p?.priceType === 'STREET_PRICE')?.value;

      // Fallback for watch/tablet when recommendation response is absent:
      // compute total financed amount = recurring installments across cycles + one-time fee.
      const hardwareOneTimeTotal = flatRecurringPrices.reduce((sum: number, price: any) => {
        return sum + (toNumberOrZero(price?.value) * getCycleMonths(price?.cycle));
      }, 0) + flatPrices
        .filter((p: any) => p?.priceType === 'ONETIME')
        .reduce((sum: number, price: any) => sum + toNumberOrZero(price?.value), 0);

      monthlyInstallment += toNumberOrZero(originalInstallment || monthlyPrices?.[0]?.price?.taxIncludedAmount?.value || flatMonthly);
      oneTimePrice += toNumberOrZero(streetPrice || flatStreet || (item?.itemType === HARDWARE ? hardwareOneTimeTotal : 0));
    }

    return {
      name,
      monthlyInstallment,
      oneTimePrice,
    };
  };

  // Get all selected items across all tabs as a flat array with cumulative prices
  const getAllSelectedItems = () => {
    let totalOneTimePrice = 0;
    let totalMonthlyPrice = 0;

    const items = (content?.recommendationType || []).flatMap((tabKey: string) => {
      const recomList = multiItemAccessoriessList?.[tabKey] || {};
      const recomIds = new Set(Object.values(recomList).map((item: any) => item?.recomApiResponse?.id));

      // Items from recommendation list that are in cart
      const recomItems = Object.values(recomList)
        .filter((item: any) => cartData?.[tabKey]?.[item?.recomApiResponse?.id])
        .map((item: any) => {
          totalOneTimePrice += +(item?.recomApiResponse?.oneTimePrice?.base || 0);
          totalMonthlyPrice += +(item?.recomApiResponse?.recurringPrice?.monthlyInstallment || 0);
          return { ...item, tabKey };
        });

      // Cart-only items not in recommendation list
      const cartOnlyItems = Object.keys(cartData?.[tabKey] || {})
        .filter((id) => !recomIds.has(id))
        .map((id) => {
          const info = getCartItemDisplayInfo(cartData[tabKey][id]);
          if (!info) return null;
          totalOneTimePrice += info.oneTimePrice;
          totalMonthlyPrice += info.monthlyInstallment;
          return {
            tabKey,
            isCartOnly: true,
            recomApiResponse: {
              id,
              name: info.name,
              oneTimePrice: { base: info.oneTimePrice },
              recurringPrice: { monthlyInstallment: info.monthlyInstallment },
            },
          };
        })
        .filter(Boolean);

      return [...recomItems, ...cartOnlyItems];
    });

    // Add rateplan monthly cost once per WATCHES/TABLETS tab that has selected items
    for (const tabKey of [WATCHES, TABLETS]) {
      const hasItemsInTab = items.some((item: any) => item?.tabKey === tabKey);
      if (hasItemsInTab) {
        const rpRawPrice =
          recommendedAccessories?.[tabKey]?.ratePlan?.derivedPrice ??
          recommendedAccessories?.[tabKey]?.ratePlan?.listPrice ??
          cartData?.ratePlanInfo?.[tabKey]?.derivedPrice ??
          cartData?.ratePlanInfo?.[tabKey]?.monthlyPrice ??
          0;
        const rpParsedPrice = Number(rpRawPrice);
        const rpPrice = Number.isFinite(rpParsedPrice) ? rpParsedPrice : 0;
        totalMonthlyPrice += rpPrice;
      }
    }

    return { items, totalOneTimePrice, totalMonthlyPrice };
  };

  const { items: allSelectedItems, totalOneTimePrice, totalMonthlyPrice } = getAllSelectedItems();
  const allTabSelectedCount = Object.values(inTabSelected).reduce((total, count) => total + count, 0);
  return (
    <>
      <Row>
      <div className={Styles.mainPage}>
        {((Object.keys(multiItemAccessoriessList?.[store?.selectedTab] || []).length >= accessoriesLimit?.[store.selectedTab]) && store?.selectedTab === ACCESSORY ) && <div className={Styles.cartLimitTxt}><RichText content={limitWarningText} /></div>}
        {(store?.selectedTab === WATCHES || store?.selectedTab === TABLETS) && <div className={Styles.extraSimHeading}>{store?.selectedTab === WATCHES ? content?.watchesHeading : content?.tabletsHeading}</div>}
        <DeviceCarouselComponent key={store?.selectedTab}>
        {(multiItemAccessoriessList?.[store?.selectedTab] || [])?.filter((item: any) => selectedPaymentType === CONTRACT ? item?.recomApiResponse?.recurringPrice?.monthlyInstallment > 0 : item)?.map((item: any, index: number) => {
          return (
          <div key={index} className={`${Styles.card} ${cartData?.[store?.selectedTab]?.[item?.recomApiResponse?.id] ? Styles.selectedCard : ''}`}>
            <div className={Styles.detailSection} id={`detailsectionv3${tabIndex}${index}`}>
            {(item?.sbStoryItem?.content?.body?.[0]?.displayText ?? item?.sbStoryItem?.displayText) && <div className={Styles.heading} id={`headingV3${tabIndex}${index}`}>
              {item?.sbStoryItem?.content?.body?.[0]?.displayText ?? item?.sbStoryItem?.displayText}
              {store?.selectedTab === ACCESSORY && item?.recomApiResponse?.variantCategory?.color && item?.recomApiResponse?.variantCategory?.color !== 'None' && <div className={Styles.optionalText}>{content?.accessoriesColorLabel} {item?.recomApiResponse?.variantCategory?.color}</div>}
            </div>}
            
            <div className={Styles.accImage} id={`image${tabIndex}${index}`}>
              {(store?.selectedTab === WATCHES || store?.selectedTab === TABLETS) && content?.esimIcon?.filename && (
              <div className={Styles.esimBadge}>
                {item?.sbStoryItem?.energyIcon?.filename && <img loading='lazy' src={getCompressedImage(basicConfigUrl, item?.sbStoryItem?.energyIcon?.filename)} alt='energy_Icon' width={37} height={20} />}
                <img src={content?.esimIcon?.filename} alt="eSIM" className={Styles.esimIcon} />
              </div>
              )}
              <img  loading='lazy' src={getCompressedImage(basicConfigUrl,item?.imageData?.image)} alt='acessories_device' width={210} height={210} />
            </div>
            </div>
            <div className={Styles.mainPriceContainer} id={`main-price-section${tabIndex}${index}`}>
            {selectedPaymentType === CONTRACT ? <div className={Styles.priceContainer} id={`price-detail-section${tabIndex}${index}`}>
              <div className={Styles.price} id={`price${tabIndex}${index}`}>
              <span style={{ color: item?.recomApiResponse?.recurringPrice?.marketMonthlyInstallment ? '#5E94CF' : '#3D3935' }}>{countZero(item?.recomApiResponse?.recurringPrice?.monthlyInstallment)}</span>
              {item?.recomApiResponse?.recurringPrice?.marketMonthlyInstallment && (
                <span className={Styles.strikedMonthlyPrice}>
                {countZero(item?.recomApiResponse?.recurringPrice?.marketMonthlyInstallment)}
                </span>
              )}
              <span className={item?.recomApiResponse?.recurringPrice?.marketMonthlyInstallment ? Styles?.monthlyStrikethroughText : Styles.monthlyText}>{content?.monthlyText}</span>
              </div>
              <div className={Styles.totalPrice}>{content?.totalText} {countZero(item?.recomApiResponse?.oneTimePrice?.base)} <span className={Styles.strikedtotalMonthlyPrice} style={{ visibility: item?.recomApiResponse?.oneTimePrice?.market ? 'visible' : 'hidden' }}>{countZero(item?.recomApiResponse?.oneTimePrice?.market)}</span></div>
              <div className={Styles.priceDescription}>{content?.monthlyPaymentLabel}<br />{content?.monthlyDownPaymentLabel}</div>
              {(item?.recomApiResponse?.includedOptions?.includes(FLEX_UPGRADE) && content?.freeFUText) && <div className={Styles.flexUpgradeText}>{content?.freeFUText}</div>}
            </div> :
              <div className={Styles.priceContainer} id={`price-detail-section${tabIndex}${index}`}>
              <div className={Styles.price} style={{ color: item?.recomApiResponse?.recurringPrice?.marketMonthlyInstallment ? '#5E94CF' : '#3D3935' }} id={`price${tabIndex}${index}`}>
                <span className={Styles.oneTimePrice}>{countZero(item?.recomApiResponse?.oneTimePrice?.base)}</span>
                {item?.recomApiResponse?.oneTimePrice?.market && (
                <span className={Styles.strikedMonthlyPrice}>
                  {countZero(item?.recomApiResponse?.oneTimePrice?.market)}
                </span>
                )}
              </div>
              <div className={Styles.priceDescription}>{content?.oneTimePaymentLabel}</div>
              </div>
            }
            {content?.addtocartButton.length > 0 && content?.removefromcartButton.length > 0 && (
              <div className={`${Styles.cartBtn}`} id={`add-crt-btn${tabIndex}${index}`}>
              {cartData?.[store?.selectedTab]?.[item?.recomApiResponse?.id] ?
                <><FalconButtonV2
                content={content?.removefromcartButton?.[0]}
                onClick={(e: any) => handleClickAddRemoveCartBtn(e, item, index)}
                wafIdentifier={basicConfigUrl}
                disabled={loading}
                />
                </> :
                <FalconButtonV2
                content={content?.addtocartButton?.[0]}
                onClick={(e: any) => handleClickAddRemoveCartBtn(e, item, index)}
                wafIdentifier={basicConfigUrl}
                disabled={loading}
                />
              }
              </div>
            )}
            </div>
          </div>
          )
        })}
        </DeviceCarouselComponent>

        <div className={Styles.miaFooter}>
          {/** Selection summary is shown only for multi-tab MIA (not old single-tab UI),
           *  contract/monthly flow (not one-time pay), and new subscriptions
           *  (existing subscription flow is blocked unless enableExistingSubscription is true (already handled in MultiItemAccessoriesPage)) */}
          {allTabSelectedCount > 0 && content?.enableSelectionSummary
            && Object.keys(recommendedAccessories || {}).length > 1
            && selectedPaymentType === CONTRACT
            && <div className={Styles.miniSummary}>
            <div className={Styles.titleRow}>
              {/**1*/}
              <span className={`fw-bold ${Styles.titleLabel}`}>{content?.yourSelectionTitle}</span>
              {/**2*/}
              <span className={Styles.titleIcons}>
                {(content?.recommendationType || []).map((tabKey: string) => {
                  return (
                    inTabSelected[tabKey] > 0 && (
                      <>
                        {((tabKey=== WATCHES && inTabSelected[ACCESSORY] > 0) ||(tabKey === TABLETS && (inTabSelected[ACCESSORY] > 0 || inTabSelected[WATCHES] > 0))) && <span><img loading='lazy' src={getCompressedImage(basicConfigUrl,content?.selectionSummaryPlusIcon?.filename)} alt='add_icon' width={16} height={16}/></span>}
                        <span><img loading='lazy' src={getCompressedImage(basicConfigUrl,summaryIcons?.[`${tabKey}_icon`])} alt={`${tabKey}_icon`} /> {inTabSelected[tabKey]}x {summaryLabels?.[`${tabKey}_title`]}</span>
                      </>
                    )
                  )
                })}
              </span>
              {/**3*/}
              <div className={`fw-bold ${Styles.cartPrice}`}>
                {selectedPaymentType === CONTRACT
                  ? <>{countZero(totalMonthlyPrice)}{content?.monthlyText}</>
                  : countZero(totalOneTimePrice)
                }
              </div>
              {/**4*/}
              {!showMiniCart ? <img className={Styles.cartToggle} onClick={() => setShowMiniCart(!showMiniCart)} loading='lazy' src={getCompressedImage(basicConfigUrl,content?.selectionSummaryExpandIcon?.filename)} alt='expand_icon' width={24} height={24}/>
                : <img className={Styles.cartToggle} onClick={() => setShowMiniCart(!showMiniCart)} loading='lazy' src={getCompressedImage(basicConfigUrl,content?.selectionSummaryCollapseIcon?.filename)} alt='expand_icon' width={24} height={24}/>}
            </div>
            {showMiniCart && (
              <>
              {/* DividerComponent */}
              <div className={Styles.miniCartDivider} />
              {allSelectedItems
                  .map((item: any) => (
                    <div className={Styles.itemRow} key={item?.recomApiResponse?.id}>
                      <div className={Styles.itemLine}>
                        <span className={Styles.itemName}>{item?.recomApiResponse?.name}</span>
                        <div className={Styles.cartPrice}>
                          {selectedPaymentType === CONTRACT
                            ? <>{item?.recomApiResponse?.oneTimePrice?.base > 0 && <span className={Styles.oneTime}>({countZero(item?.recomApiResponse?.oneTimePrice?.base)})</span>}
                              {countZero(item?.recomApiResponse?.recurringPrice?.monthlyInstallment)}{content?.monthlyText}</>
                            : countZero(item?.recomApiResponse?.oneTimePrice?.base)
                          }
                        </div>
                        <img
                          className={Styles.cartDelete}
                          loading='lazy'
                          src={getCompressedImage(basicConfigUrl, content?.selectionSummaryDeleteIcon?.filename)}
                          alt='delete_icon'
                          onClick={() => handleDeleteFromMiniCart(item)}
                          width={20}
                          height={20}
                        />
                      </div>
                      {[WATCHES, TABLETS].includes(item?.tabKey) &&<div className={Styles.itemLine}>
                        <span className={`${Styles.itemName} ${Styles.rpName}`}>{recommendedAccessories?.[item?.tabKey]?.ratePlan?.id || cartData?.ratePlanInfo?.[item?.tabKey]?.name}</span>
                        <div className={Styles.rpPrice}>
                          {countZero(Number.isFinite(Number(
                            recommendedAccessories?.[item?.tabKey]?.ratePlan?.derivedPrice ??
                            recommendedAccessories?.[item?.tabKey]?.ratePlan?.listPrice ??
                            cartData?.ratePlanInfo?.[item?.tabKey]?.derivedPrice ??
                            cartData?.ratePlanInfo?.[item?.tabKey]?.monthlyPrice ??
                            0
                          ))
                            ? Number(
                              recommendedAccessories?.[item?.tabKey]?.ratePlan?.derivedPrice ??
                              recommendedAccessories?.[item?.tabKey]?.ratePlan?.listPrice ??
                              cartData?.ratePlanInfo?.[item?.tabKey]?.derivedPrice ??
                              cartData?.ratePlanInfo?.[item?.tabKey]?.monthlyPrice ??
                              0
                            )
                            : 0)}{content?.monthlyText}
                        </div>
                      </div>}
                      {/* DividerComponent */}
                      <hr className={Styles.itemDivider} />
                    </div>
                  ))
              }
              </>
            )
            }

          </div>}
          <div className={`${Styles.checkoutBtn}`}>
            {content?.proceedtocheckoutButton?.length > 0 && (
              <FalconButtonV2
              content={content.proceedtocheckoutButton[0]}
              eventAction={''}
              onClick={(e: any) => multiItemAccesoryCreatecart(e)}
              wafIdentifier={basicConfigUrl}
              disabled={loading}
              />
            )}
          </div>
        </div>
      </div>
      </Row>
      {show && <AccessoryModal
      modalState={show}
      handler={() => { onCloseClick() }}
      showFooter={false}
      height={'auto'}
      fixedWidth={(viewPort === 'large-desktop' || viewPort === 'desktop' || viewPort === 'tablet') ? '460px' : ''}
      noCloseButton={false}
      backDrop={true}
      > <div className={`${Styles.accessoryErrorUpdate}`}>
        <RichText content={content?.errorModal?.[0]?.heading} />
        <RichText content={content?.errorModal?.[0]?.description} />
        <div className={`${Styles.accessoryErrorButtons}`}>
        <div className={`${Styles.cancelButton}`} onClick={() => { onCloseClick() }}>{content?.cancelButtonLinkText}</div>
        <FalconButtonV2
          content={content?.retryButton?.[0]}
          onClick={(e: any) => multiItemAccesoryCreatecart(e)}
          metadata={undefined}
          wafIdentifier={basicConfigUrl}
        />
        </div>
      </div>
      </AccessoryModal>
      }
      {showCartLimitError && store?.selectedTab === ACCESSORY && <AccessoryModal
      modalState={showCartLimitError}
      handler={() => { onCloseClickCartLimitPopup() }}
      showFooter={false}
      height={'auto'}
      fixedWidth={(viewPort === 'large-desktop' || viewPort === 'desktop' || viewPort === 'tablet') ? '624px' : ''}
      noCloseButton={false}
      backDrop={true}>
      <div className={`${Styles.accessoryErrorUpdate}`}>
        <RichText content={JSON.parse(
        replacePlaceholder(JSON.stringify(content?.cartLimitModal?.[0]?.heading), [
          accessoriesLimit?.[store.selectedTab].toString()
        ])
        )} />
        <RichText content={JSON.parse(
        replacePlaceholder(JSON.stringify(content?.cartLimitModal?.[0]?.description), [
          accessoriesLimit?.[store.selectedTab].toString()
        ])
        )} />
        <div className={`${Styles.accessoryErrorButtons}`}>
        <div className={`${Styles.cancelButton}`} onClick={() => { onCloseClickCartLimitPopup() }}>{content?.cartLimitBtnText}</div>
        </div>
      </div>
      </AccessoryModal>}
      
      {/* Selection Limit Modal for Watches and Tablets */}
      {showCartLimitError && (store?.selectedTab === WATCHES || store?.selectedTab === TABLETS) && (() => {
        const selectionContent = getSelectionPopupContent();
        // Track popup open event, limit description to 100 chars max
        // const desc = typeof selectionContent?.description === 'string'
        //   ? selectionContent.description
        //   : JSON.stringify(selectionContent?.description ?? '');
        trackNewDatalayerEvent(GAEVENT, OPENPOPUP, {
          component: POPUP,
          message_title: REPLACESELECTION,
          message_description: selectionContent?.description?.content?.[0]?.content?.[0]?.text?.slice(0, 100),
          message_type: INFO
        });
        return (
          <AccessoryModal
            modalState={showCartLimitError}
            handler={() => handleClosePopup(selectionContent) }
            showFooter={false}
            height={'auto'}
            fixedWidth={(viewPort === 'large-desktop' || viewPort === 'desktop' || viewPort === 'tablet') ? '624px' : ''}
            noCloseButton={false}
            backDrop={true}
          >
            <>
              {selectionContent?.heading && (
                <div className={Styles.modalHeading}>
                  <RichText content={selectionContent.heading} />
                </div>
              )}
              
              {selectionContent?.description && (
                <div className={Styles.modalDescription}>
                  <RichText content={selectionContent.description} />
                </div>
              )}
              
              <div className={Styles.modalButtons}>
                {selectionContent?.link && (
                  <a 
                    className={Styles.factSheetLink}
                    onClick={() => handleKeepPrevious()}
                  >
                    {selectionContent.linkText}
                  </a>
                )}
                
                {selectionContent?.button?.length > 0 && (
                  <FalconButtonV2
                    content={selectionContent.button[0]}
                    onClick={() => handleReplaceSelection()}
                    metadata={undefined}
                    wafIdentifier={''}
                  />
                )}
              </div>
            </>
          </AccessoryModal>
        );
      })()}
    </>
  );
}

export default AccessoryCard;